import { ReactIntegration, createReactRouterV6DataOptions, getWebInstrumentations, initializeFaro } from '@grafana/faro-react'
import { TracingInstrumentation } from '@grafana/faro-web-tracing'
import { matchRoutes } from 'react-router-dom'
import { APP_COMMIT_HASH, APP_VERSION } from '../utils/appVersion'

export function initFaro() {
  const url = `${dex.config.faro.url}/${dex.config.faro.token}`
  initializeFaro({
    url,
    app: {
      name: 'Admin Review Tool',
      version: APP_VERSION,
      gitHash: APP_COMMIT_HASH,
      environment: dex.config.name
    },
    consoleInstrumentation: {
      disabledLevels: []
    },

    instrumentations: [
      // Mandatory, omits default instrumentations otherwise.
      ...getWebInstrumentations({
        captureConsole: true
      }),

      // Tracing package to get end-to-end visibility for HTTP requests.
      new TracingInstrumentation(),

      // React integration for React applications.
      new ReactIntegration({
        router: createReactRouterV6DataOptions({
          matchRoutes
        })
      })
    ]
  })
}
